export let NotEntitledJustification;

(function (NotEntitledJustification) {
  NotEntitledJustification["MISSING_PERMISSION"] = "MISSING_PERMISSION";
  NotEntitledJustification["MISSING_FEATURE"] = "MISSING_FEATURE";
  NotEntitledJustification["BUNDLE_EXPIRED"] = "BUNDLE_EXPIRED";
})(NotEntitledJustification || (NotEntitledJustification = {}));

export const ADMIN_PORTAL_ENTITLEMENTS_FF = 'admin_portal_entitlements';